import { useMemo } from 'react';
import { Tag } from '@brg/api';
import { useDomainsPlatform } from './useDomainsPlatform';

interface AlternateDomainInfo {
  domain: string;
  canonicalType?: number;
}

export const useProjectCanonicalInfo = (
  projectTags: (Tag<'Local'> & { isEducationTag: boolean; isTeamTag: boolean })[]
): { canonicalInfo?: any; alternateDomainInfo?: AlternateDomainInfo[] } => {
  const domainsMap = useDomainsPlatform(true);
  const tagWithCanonical = useMemo(() => {
    return projectTags.find(tag => {
      if (!tag?.isEducationTag || !(tag as any)?.canonicalInfo?.contextInfos?.length) return false;
      const contextInfos = (tag as any).canonicalInfo.contextInfos || [];
      return contextInfos.some((ctx: any) => domainsMap.get(ctx.domain) !== 'gallery');
    });
  }, [projectTags, domainsMap]);

  const canonicalInfo = useMemo(() => {
    if (!tagWithCanonical || !(tagWithCanonical as any)?.canonicalInfo?.contextInfos?.length) {
      return undefined;
    }
    
    const canonicalInfoData = (tagWithCanonical as any).canonicalInfo;
    const filteredContextInfos = (canonicalInfoData.contextInfos || []).filter((ctx: any) => domainsMap.get(ctx.domain) !== 'gallery');

    if (!filteredContextInfos.length) {
      return undefined;
    }

    return {
      ...canonicalInfoData,
      contextInfos: filteredContextInfos,
    };
  }, [tagWithCanonical, domainsMap]);

  const alternateDomainInfo = useMemo(() => {
    if (!tagWithCanonical || !(tagWithCanonical as any)?.alternateDomainInfo) {
      return undefined;
    }
    const alternateDomainInfo = (tagWithCanonical as any).alternateDomainInfo;
    if (!Array.isArray(alternateDomainInfo)) {
      return undefined;
    }
    return alternateDomainInfo
      .map((ctx: any) => ({
        domain: ctx.url || ctx.domain || ctx.appName || '',
        canonicalType: ctx.canonicalType || 0
      }))
      .filter((ctx: any) => ctx.domain && ctx.domain !== 'unknown' && ctx.domain !== '');
  }, [tagWithCanonical]);

  return {
    canonicalInfo,
    alternateDomainInfo
  };
};
import { useMemo } from 'react';
import { Tag } from '@brg/api';
import { useDomainsPlatform } from './useDomainsPlatform';

interface AlternateDomainInfo {
  domain: string;
  canonicalType?: number;
}

export const useProjectCanonicalInfo = (
  projectTags: (Tag<'Local'> & { isEducationTag: boolean; isTeamTag: boolean })[]
): { canonicalInfo?: any; alternateDomainInfo?: AlternateDomainInfo[] } => {
  const domainsMap = useDomainsPlatform(true);
  const tagWithCanonical = useMemo(() => {
    return projectTags.find(tag => {
      if (!tag?.isEducationTag || !(tag as any)?.canonicalInfo?.contextInfos?.length) return false;
      const contextInfos = (tag as any).canonicalInfo.contextInfos || [];
      return contextInfos.some((ctx: any) => domainsMap.get(ctx.domain) !== 'gallery');
    });
  }, [projectTags, domainsMap]);

  const canonicalInfo = useMemo(() => {
    if (!tagWithCanonical || !(tagWithCanonical as any)?.canonicalInfo?.contextInfos?.length) {
      return undefined;
    }
    
    const canonicalInfoData = (tagWithCanonical as any).canonicalInfo;
    const filteredContextInfos = (canonicalInfoData.contextInfos || []).filter((ctx: any) => domainsMap.get(ctx.domain) !== 'gallery');

    if (!filteredContextInfos.length) {
      return undefined;
    }

    return {
      ...canonicalInfoData,
      contextInfos: filteredContextInfos,
    };
  }, [tagWithCanonical, domainsMap]);

  const alternateDomainInfo = useMemo(() => {
    if (!tagWithCanonical || !(tagWithCanonical as any)?.alternateDomainInfo) {
      return undefined;
    }
    const alternateDomainInfo = (tagWithCanonical as any).alternateDomainInfo;
    if (!Array.isArray(alternateDomainInfo)) {
      return undefined;
    }
    return alternateDomainInfo
      .map((ctx: any) => ({
        domain: ctx.url || ctx.domain || ctx.appName || '',
        canonicalType: ctx.canonicalType || 0
      }))
      .filter((ctx: any) => ctx.domain && ctx.domain !== 'unknown' && ctx.domain !== '');
  }, [tagWithCanonical]);

  return {
    canonicalInfo,
    alternateDomainInfo
  };
};
